import {createFileRoute, redirect} from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_admin/_legacy/tiktok-media-manager")({
  beforeLoad: () => {
    throw redirect({to: "/admins/tiktok-media-manager", replace: true});
  },
});
